module.exports = __webpack_public_path__ + "static/media/banner_slider_1.f5d2006a.jpeg";